/**
 * File: InfoHint.tsx
 * Path: apps/admin/src/shared/components/InfoHint.tsx
 * Description: A small (i) that opens a plain sentence. The list pages use it
 * where a figure used to carry an explaining line of its own (admin UI audit
 * C8). TermHint does the same for the accounting terms.
 */

import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";

export const InfoHint: React.FC<{ name: string; children: React.ReactNode }> = ({ name, children }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={`What ${name} means`}
        className="inline-flex h-6 w-6 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info className="h-4 w-4" aria-hidden />
      </button>
    </PopoverTrigger>
    <PopoverContent collisionPadding={16} className="w-64 max-w-[calc(100vw-2rem)] text-sm">
      <p className="font-bold">{name}</p>
      <p>{children}</p>
    </PopoverContent>
  </Popover>
);
